import { createSelector } from 'reselect';
import { RootState } from '../rootReducer';
import { UnsubscribeGroupsState } from '../../types/unsubscribeGroups/unsubscribeGroups.types';

// Base selector
const selectUnsubscribeGroupsState = (
  state: RootState
): UnsubscribeGroupsState => state.unsubscribeGroups;

// Memoized selectors
export const selectUnsubscribeGroups = createSelector(
  [selectUnsubscribeGroupsState],
  (unsubscribeGroupsState) => unsubscribeGroupsState.unsubscribeGroups
);

export const selectSelectedUnsubscribeGroup = createSelector(
  [selectUnsubscribeGroupsState],
  (unsubscribeGroupsState) => unsubscribeGroupsState.selectedUnsubscribeGroup
);

export const selectUnsubscribeGroupsLoading = createSelector(
  [selectUnsubscribeGroupsState],
  (unsubscribeGroupsState) => unsubscribeGroupsState.loading
);

export const selectUnsubscribeGroupsError = createSelector(
  [selectUnsubscribeGroupsState],
  (unsubscribeGroupsState) => unsubscribeGroupsState.error
);

export const selectUnsubscribeGroupsSuccess = createSelector(
  [selectUnsubscribeGroupsState],
  (unsubscribeGroupsState) => unsubscribeGroupsState.success
);

// Derived selectors
export const selectUnsubscribeGroupById = (id: string) =>
  createSelector([selectUnsubscribeGroups], (unsubscribeGroups) =>
    unsubscribeGroups.find((unsubscribeGroup) => unsubscribeGroup._id === id)
  );
